/* World Spice 2026 product page — behavior for sections/ws-main-product.liquid.

   Deliberately small: the buy box is the theme's own product-variant-picker /
   buy-buttons markup driven by variant-selects.js + product-info.js. This file
   only adds the three things the design needs on top of that:
     1. gallery thumb switching (incl. the synthetic tin-label view)
     2. the Spice 101 accordion
     3. the "Add <Form> <Title> to cart · $price" button label

   Loaded by several sections potentially, so it self-guards like ws-home.js. */
(function () {
  'use strict';

  if (window.__wsPdpInit) return;
  window.__wsPdpInit = true;

  var ROOT = '.ws-pdp';

  /* ---------- helpers ---------- */

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function money(cents) {
    try {
      if (window.FoxTheme && FoxTheme.Currency && FoxTheme.Currency.formatMoney) {
        return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
      }
    } catch (err) {
      /* fall through */
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  /* ---------- gallery ---------- */

  function showView(gallery, key) {
    if (!gallery || key == null) return;
    gallery.querySelectorAll('.gthumb').forEach(function (t) {
      t.classList.toggle('is-on', t.getAttribute('data-view') === key);
      t.setAttribute('aria-selected', t.getAttribute('data-view') === key ? 'true' : 'false');
    });
    gallery.querySelectorAll('.gview').forEach(function (v) {
      v.classList.toggle('is-on', v.getAttribute('data-view') === key);
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest(ROOT + ' .gthumb');
    if (!thumb) return;
    showView(thumb.closest('.gal'), thumb.getAttribute('data-view'));
  });

  /* Variant images: product-info.js drives the theme's <media-gallery>, which
     this section does not use, so mirror its behavior here. */
  function syncGalleryToVariant(root, variant) {
    if (!variant || !variant.featured_media) return;
    var gallery = root.querySelector('.gal');
    if (!gallery) return;
    var view = gallery.querySelector('.gview[data-media-id="' + variant.featured_media.id + '"]');
    if (view) showView(gallery, view.getAttribute('data-view'));
  }

  /* ---------- Spice 101 accordion ---------- */

  document.addEventListener('click', function (e) {
    var q = e.target.closest(ROOT + ' .s101__q');
    if (!q) return;
    var row = q.closest('.s101__row');
    if (!row) return;
    var open = !row.classList.contains('is-open');
    row.classList.toggle('is-open', open);
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- add-to-cart label ---------- */

  function labelFor(root, variant) {
    if (!variant) return null;
    var title = String(variant.name || '').split(' - ')[0] || '';
    var form = '';
    (variant.options || []).forEach(function (opt) {
      var o = String(opt || '');
      if (/^(whole|ground)$/i.test(o)) form = o;
      if (/sample/i.test(o)) form = 'Sample';
    });
    var out = 'Add ';
    if (form) out += '<b>' + escapeHtml(form) + '</b> ';
    out += escapeHtml(title) + ' ' + escapeHtml(root.getAttribute('data-atc-suffix') || 'to cart');
    if (variant.price != null) {
      out += ' <span class="ws-atc__price">· ' + escapeHtml(money(variant.price)) + '</span>';
    }
    return out;
  }

  function updateAddButton(root, variant) {
    var span = root.querySelector('#in-page-add-to-cart');
    if (!span) return;
    var button = span.closest('button');
    if (button && button.hasAttribute('disabled')) return; /* sold out / unavailable text wins */
    var html = labelFor(root, variant);
    if (html) span.innerHTML = html;
  }

  function selectedVariant(root) {
    var node = root.querySelector('variant-selects [data-selected-variant]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  /* product-info.js re-labels the button on every variant change, so run after it. */
  document.addEventListener('variant:changed', function (e) {
    document.querySelectorAll(ROOT).forEach(function (root) {
      updateAddButton(root, e.detail && e.detail.variant);
      syncGalleryToVariant(root, e.detail && e.detail.variant);
    });
  });

  /* ---------- accessible group labels ----------

     The design labels the option rows "Packaging" and "Size". Those words are
     drawn by CSS `content:` in ws-pdp.css, because the variant picker is shared
     with six other product templates and cannot be edited here — and its own
     legends are hidden with an inline `display:none`, which takes them out of
     the accessibility tree too.

     CSS `content:` is not reliably announced, so a screen reader would meet two
     unlabelled groups of buttons. Name the groups on the elements themselves.
     Reading the words back off the custom property keeps one source of truth:
     the merchant edits the setting, and both the visible label and the
     announced one follow. */

  function labelGroups(root) {
    var styles = getComputedStyle(root);

    [
      ['.epk-format', '--ws-pdp-label-packaging', 'Packaging'],
      ['.epk-sizes', '--ws-pdp-label-size', 'Size']
    ].forEach(function (pair) {
      var group = root.querySelector(pair[0]);
      if (!group || group.getAttribute('aria-label')) return;

      // The property value arrives quoted, the way `content:` wants it.
      var name = (styles.getPropertyValue(pair[1]) || '').trim().replace(/^["']|["']$/g, '');

      group.setAttribute('role', 'group');
      group.setAttribute('aria-label', name || pair[2]);
    });
  }

  /* ---------- init ---------- */

  function init(scope) {
    (scope || document).querySelectorAll(ROOT).forEach(function (root) {
      updateAddButton(root, selectedVariant(root));
      labelGroups(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
